export default ({ request }) => ({
  ecomAmzFlipOrderDashboardApi(data = {}) {
    return request({
      url: '/ecom/amz/flip/order/dashboard',
      method: 'POST',
      data,
    })
  },
})
